<input type="file" [id]="elementID" style="display: none" [accept]="accept" name="file" (change)="fileChange($event.target)" [multiple]="isMultiple" />